import React from 'react';
import SectionTitle from '../Common/SectionTitle';

const TeamMember = ({ image, name, position }) => {
  return (
    <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={100 * (parseInt(image.split('-')[1]) || 1)}>
      <div className="member">
        <div className="pic"><img src={`/assets/img/team/${image}`} className="img-fluid" alt="" /></div>
        <div className="member-info">
          <h4>{name}</h4>
          <span>{position}</span>
          <div className="social">
            <a href="https://twitter.com"><i className="bi bi-twitter-x"></i></a>
            <a href="https://facebook.com"><i className="bi bi-facebook"></i></a>
            <a href="https://instagram.com"><i className="bi bi-instagram"></i></a>
            <a href="https://linkedin.com"><i className="bi bi-linkedin"></i></a>
          </div>
        </div>
      </div>
    </div>
  );
};

const Team = () => {
  const teamMembers = [
    { image: 'team-1.jpg', name: 'Bhuvan Gupta', position: 'Chief Executive Officer' },
    { image: 'team-2.jpg', name: 'Pooja Gupta', position: 'General Manager' },
    { image: 'team-3.jpg', name: 'Tarun Kaushik', position: 'Manager' }
  ];

  return (
    <section id="team" className="team section">
      <SectionTitle 
        title="Team" 
        description1="Check Our" 
        description2="Team" 
      />

      <div className="container">
        <div className="row gy-5">
          {teamMembers.map((member, index) => (
            <TeamMember 
              key={index}
              image={member.image}
              name={member.name}
              position={member.position}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team; 